import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddDealComponent } from './add-deal.component';

const routes: Routes = [{ path: '', component: AddDealComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AddDealRoutingModule {}
